class Product {

    constructor() {
        this.bindLoadEvents();
    }

    bindLoadEvents() {
        this.initMobileFilters();
    }

    initMobileFilters() {

        let self = this;

        $('.mobile-filter-toggle').click( function(e) {
            e.preventDefault();

            $('body').addClass('position-fixed');
            let filter = $(this);

            //- Check if any menus are active
            let active_menu = self.hasActiveMenus();

            //- If no menus are open, open the chosen one.
            if (active_menu == false) {
                self.openMenu($(this));
            }

            //- If a menu is open and a different one is clicked, shut down the current one and open a new one.
            if (active_menu != false && active_menu == filter.attr('id')) {
                self.shutMenu(active_menu);
            }

            let active_menu_end = self.hasActiveMenus();
            if (active_menu_end == false) {
                $('body').removeClass('position-fixed');
            }

        });

    }

    openMenu(e) {
        let term = $(e).attr('id');
        $('.mobile-filter-values').removeClass('d-none').addClass('d-flex');
        $('[data-term-slug="'+term+'"]').removeClass('d-none').addClass('d-flex');
        $(e).removeClass('inactive').addClass('active');
        $('.filter-wrapper').removeClass('inactive').addClass('active');
    }

    hasActiveMenus() {
        let returnable = false;
        $('.mobile-filter-toggle').each( function(i, v) {
            if ($(v).hasClass('active') == true) {
                returnable = $(v).attr('id');
                return false;
            }
        });
        return returnable;
    }

    shutMenu(id) {
        let filter = $('#'+id);
        $(filter).removeClass('active').addClass('inactive');
        $('[data-term-slug="'+$(filter).attr('id')+'"]').removeClass('d-flex').addClass('d-none');
        $('.mobile-filter-values').removeClass('d-flex').addClass('d-none');
        $('.filter-wrapper').removeClass('active').addClass('inactive');
    }


}

export default Product;